import * as React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { Bullseye, PageSection } from '@patternfly/react-core';

const SignInPage = (): React.ReactElement => (
  <PageSection isFilled>
    <Bullseye>
      <SignIn routing="path" path="/sign-in" />
    </Bullseye>
  </PageSection>
);

export default SignInPage;
